import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class CommonButton extends React.Component {
	render() {
		return (
			<Button
				bsStyle={null}
				bsSize={this.props.bsSize}
				className={`btn-pswp btn-link mt-1 text-white ${
					this.props.buttonClasses
				}`}
				onClick={this.props.onClick}
			>
				<i
					className={[
						'ddc-icon',
						this.props.iconClass,
						'text-white'
					].join(' ')}
				/>{' '}
				<span>{this.props.buttonName}</span>
			</Button>
		);
	}
}
CommonButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	iconClass: PropTypes.string.isRequired,
	buttonName: PropTypes.string.isRequired,
	bsSize: PropTypes.string.isRequired,
	buttonClasses: PropTypes.string.isRequired
};

export default CommonButton;



// WEBPACK FOOTER //
// ./src/components/photoswipe/CommonButton.jsx